<template>
    <!-- <q-slide-transition> -->
    <div class="answer-box" v-if="visible">
        <template v-if="!props?.isCore">
            <div style="display: inline-flex; margin-bottom: 1.5vmin; align-items: center">
                <b>정답</b>
                <div class="answer_number">{{ getNumberAnswer((answer.texts.replace('<br />', '').replaceAll(' ', ''))) }}</div>
            </div>
            <!-- <p v-html="answer.detail"></p> -->
        </template>
        <template v-if="props?.isCore">
            <div><b>정답</b></div>
            <!-- <p v-html="answer.detail"></p> -->
            <p v-html="answer.texts"></p>
        </template>
        <div v-if="answer.explain"><b>해설</b></div>
        <p v-html="answer.explain"></p>
        <div v-if="answer.hint"><b>오답피하기</b></div>
        <p v-html="answer.hint"></p>
        <div v-if="videoVisible && videoUrl" style="margin-bottom: 10px"><b>해설 영상</b></div>
        <VideoTest
            v-if="videoVisible && videoUrl"
            :videoSrc="videoUrl"
            @setVideoStatus="
                () => {
                    // videoComplete = true;
                    // nextBtn = true;
                    // preBtn = true;
                    emit('setVideoStatus');
                }
            "
            :key="props.pContent.problemId"
        />
        <div id="observerDiv" class="example-observed text-center rounded-borders">&nbsp;</div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps, watch, toRaw, defineEmits } from 'vue';
import VideoTest from '@/components/qbank/VideoTest';
import { getAnswer, getEtcInfo } from '@/helpers/qbankParser/qbankDataParse';
import { getKrtProblem } from '@/api/modules/qbank';
import { getNumberAnswer } from '@/helpers/utils';

const answer = ref('');
const videoUrl = ref(null);
const videoVisible = ref(false);
const completeVideo = ref(false);
const visible = ref(false);
const videoDialog = ref(false);
// const rProblem = ref(null);
const intersection = ref(false);
let io = null;

const emit = defineEmits(['onIntersection']);

const props = defineProps({
    pContent: {
        default: {},
    },
    answerNoti: false,
    isCore: {
        default: false,
    },
});

const init = (newValue) => {
    const vContent = toRaw(newValue);
    answer.value = getAnswer(vContent.data);
    // videoUrl.value = process.env.VUE_APP_DS_QBANK_ASSET_URL + vContent.data.content.property.problem.listen;
    // videoUrl.value = 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10';
    videoUrl.value = vContent.videoUrl;
    visible.value = vContent.result && vContent.result.marking !== 'halfWrong' ? true : false;
    completeVideo.value = vContent.completeVideo;
    // visible.value = true;
    // if (vContent.data.content.property.analysis?.studyTree !== '코어독해') {
    //     const relationId =
    //         vContent.data.content.property.problem.relations ? vContent.data.content.property.problem.relations[0].relationId : null;
    //     if (relationId) {
    //         getKrtProblem({
    //             version: '1.00.01', problemId: relationId
    //             // version: '1.00.01', problemId: 382222
    //         }, (r) => {
    //             rProblem.value = {
    //                 problemNo: 1,
    //                 problemId: r.content.problemId,
    //                 etcInfo: null,
    //                 data: r,
    //                 studyTime: 0,
    //                 answer: null,
    //                 reAnswer: null,
    //                 result: null,
    //             }
    //         });
    //     }
    // }
    if (vContent.result && vContent.result.marking !== 'halfWrong') {
        setTimeout(() => {
            try {
                const Element = document.querySelector('#observerDiv');
                // if (io) {
                //     io.unobserve(Element);
                // }
                const options = {};
                io = new IntersectionObserver((entries, observer) => {
                    entries.forEach((entry) => {
                        onIntersection(entry);
                    });
                }, options);
                io.observe(Element);
            } catch (error) {
                // observe error
            }
        }, 100);
    }
};

watch(
    () => props.pContent,
    (newValue) => {
        visible.value = false;
        init(newValue);
    },
);

onMounted(() => {
    init(props.pContent);
});

onUnmounted(() => {
    visible.value = false;
    videoVisible.value = false;
});

// 스크롤 하단시 액션
const onIntersection = (entry) => {
    intersection.value = entry;
    if (entry.isIntersecting) {
        emit('onIntersection');
        videoVisible.value = true;
    }
    // io.disconnect();
};
</script>

<style lang="scss" scoped>
.answer-box {
    padding: 20px;
    margin: 20px 0;
    background: #eeeeee;
    border-radius: 10px;
    font-size: 15.6pt;
}

::v-deep .q-dialog__inner {
    justify-content: end;
}

.q-dialog__inner :deep {
    justify-content: end;
}

.answer_number {
    width: 30px;
    height: 31px;
    text-align: center;
    margin-left: 1vmin;
    border-radius: 50%;
    border: 1px solid #4659ff;
    background-color: #4659ff;
    color: white;
    line-height: 30px;
}
</style>
